<script setup>
import ChartBar from '../chart/ChartBar.vue'
import FilterSetting from '~/components/data-filters/FilterSetting.vue'
import { useStationDataStore } from '~/stores/stations'
import AppLoadingWrapper from '~/components/app/AppLoadingWrapper.vue'
import DataItem from '~/components/data-views/DataItem.vue'
import CardStat from '~/components/card/CardStat.vue'
import CardStatWrapper from '~/components/layout/CardStatWrapper.vue'

const stationStore = useStationDataStore()
const stationsGroupedByFuelTypeArray = computed(() => {
  return stationStore.getFilteredStationsGropedByFuelType.map((item) => ({
    label: item.fuelType.title,
    value: item.stationCount,
  }))
})

const stationsGroupedByType = computed(() => stationStore.getStationsGroupedByType)

const filterSettings = computed(() => stationStore.filterSettings)
</script>
<template>
  <FilterSetting content-type="station" :setting="filterSettings.liquidFuelTypes" class="my-4 sm:mr-4" />
  <Divider />
  <CardStatWrapper>
    <CardStat label="Antal stationer" :value="stationsGroupedByType?.existing?.stations?.length" />
  </CardStatWrapper>
  <AppLoadingWrapper :is-loading="stationsGroupedByFuelTypeArray.length === 0" :height="100">
    <DataItem title="Fördelat på drivmedel" description="Total antal stationer per typ">
      <ChartBar :data="stationsGroupedByFuelTypeArray" direction="horizontal" />
    </DataItem>
    <DataSource :source-data="[{ identifier: 'tankaGront' }, { identifier: 'biofuelExpress' }]" />
  </AppLoadingWrapper>
</template>
